// The left-to-right mark ('\u200E') indicates that the browser should not attempt any right-to-left conversion which can cause formatting errors.
// See more: https://en.wikipedia.org/wiki/Left-to-right_mark
export const sliderLocale = {
    selectedRange: ({ start, end }) => `\u200E${start} to ${end}`,
    startAriaLabel: 'Start',
    endAriaLabel: 'End',
};
//# sourceMappingURL=Slider.locale.js.map